module.exports = __webpack_public_path__ + "static/fabric-table-basic-743b73c781175e2490e1c8ead5a0b7aa.png";